var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-wrapper"}},[_c('div',{staticClass:"loading-ring",style:(_vm.ringStyle)},[_c('div',{staticClass:"outer"}),_c('div',{staticClass:"middle"}),_c('div',{staticClass:"inner"})]),(_vm.text)?_c('div',{staticClass:"text",style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }